<template>
  <b-container fluid>
    <iq-card>
      <template v-slot:headerTitle>
        <h4 class="card-title title-typography-color">
          <i class="ri-calendar-event-fill"></i>
          {{ $t("public.views.Pages.Patient.Schedule.bookAppoiment") }}
        </h4>
      </template>
      <template v-if="!hasAnyCita" v-slot:body>
        <div class="vue-form-wizard md">
          <div class="wizard-header">
            <h4 class="wizard-title">
              {{ $t("public.views.Pages.Patient.Schedule.formWizard.title") }}
            </h4>
            <p class="category">
              {{
                $t(
                  "public.views.Pages.Patient.Schedule.formWizard.hasNotProfessionals"
                )
              }}
            </p>
          </div>
        </div>
      </template>
      <template v-else v-slot:body>
        <form-wizard color="#0cb0c2" shape="square" v-bind:subtitle="''" v-bind:title="
                $t('public.views.Pages.Patient.Schedule.formWizard.title')
              ">
          <tab-content icon="far fa-comment-alt" v-bind:title="$t('public.views.Pages.Ipros.formWizard.title1')">
            <b-form-group label-for="organization">
              <template slot="label">{{ $t("public.views.Pages.Patient.Schedule.organization") }}: *
              </template>
              <b-avatar class="mr-3" square
                v-bind:src="selectedOrganization.logoUrl + '/' + getAuthentication()"></b-avatar>
              <span class="mr-auto title-typography-color">{{
                selectedOrganization.name
                }}</span>
            </b-form-group>
            <b-form-group label-for="professional">
              <template slot="label">
                {{ $t("public.views.Pages.Patient.Schedule.professional") }}: *
              </template>

              <multiselect v-model="professional" :multiple="false" :options="professionalSelect" label="text"
                track-by="value" v-bind:class="{
                      'text-danger': isFormProfessionalErrors,
                      'is-invalid': isFormProfessionalErrors,
                    }" v-bind:deselectGroupLabel="
                      $t(
                        'public.views.Pages.Patient.Schedule.multiselect.deselectGroupLabel'
                      )
                    " v-bind:deselectLabel="
                      $t(
                        'public.views.Pages.Patient.Schedule.multiselect.deselectLabel'
                      )
                    " v-bind:placeholder="
                      $t(
                        'public.views.Pages.Patient.Schedule.multiselect.placeholder2'
                      )
                    " v-bind:selectGroupLabel="
                      $t(
                        'public.views.Pages.Patient.Schedule.multiselect.selectGroupLabel'
                      )
                    " v-bind:selectLabel="
                      $t(
                        'public.views.Pages.Patient.Schedule.multiselect.selectLabel'
                      )
                    " v-bind:selectedLabel="
                      $t(
                        'public.views.Pages.Patient.Schedule.multiselect.selectedLabel'
                      )
                    " @blur="checkProfessional(professional)" @input="changeProfessional(professional)">
                <template slot="option" slot-scope="props">
                  <b-list-group-item class="d-flex align-items-center">
                    <b-avatar class="mr-3" v-bind:src="props.option.avatar"></b-avatar>
                    <span class="mr-auto title-typography-color">{{
                      props.option.text
                      }}</span>
                  </b-list-group-item>
                </template>
                <template v-if="props.option.text" slot="singleLabel" slot-scope="props"><span class="option__desc"><span
                      class="option__title">
                      <b-avatar class="mr-3" v-bind:src="props.option.avatar"></b-avatar><span
                        class="mr-auto title-typography-color">{{
                        props.option.text
                        }}</span>
                    </span></span></template>
                <template slot="selection" slot-scope="{ values, isOpen }"><span v-if="values.length && !isOpen"
                    class="multiselect__single">{{ values.length }}
                    {{
                    $t(
                    "public.views.Pages.Patient.Schedule.selectedProfessionals"
                    )
                    }}</span></template>
              </multiselect>
              <ul v-if="isFormProfessionalErrors">
                <li v-for="(error, index) in validatorStep1.getErrors(
                        'professional'
                      )" v-bind:key="index" class="form-text text-danger">
                  &nbsp;{{ error }}
                </li>
              </ul>
            </b-form-group>
            <b-form-group label-for="visitType">
              <template slot="label">
                {{ $t("public.views.Pages.Patient.Schedule.visitType") }}: *
              </template>

              <multiselect v-model="visitType" :multiple="false" :options="visitTypeSelect" label="text" track-by="value"
                v-bind:class="{
                      'text-danger': isFormVisitTypeErrors,
                      'is-invalid': isFormVisitTypeErrors,
                    }" v-bind:deselectGroupLabel="
                      $t(
                        'public.views.Pages.Patient.Schedule.multiselect.deselectGroupLabel'
                      )
                    " v-bind:deselectLabel="
                      $t(
                        'public.views.Pages.Patient.Schedule.multiselect.deselectLabel'
                      )
                    " v-bind:placeholder="
                      $t(
                        'public.views.Pages.Patient.Schedule.multiselect.placeholder'
                      )
                    " v-bind:selectGroupLabel="
                      $t(
                        'public.views.Pages.Patient.Schedule.multiselect.selectGroupLabel'
                      )
                    " v-bind:selectLabel="
                      $t(
                        'public.views.Pages.Patient.Schedule.multiselect.selectLabel'
                      )
                    " v-bind:selectedLabel="
                      $t(
                        'public.views.Pages.Patient.Schedule.multiselect.selectedLabel'
                      )
                    " @blur="checkVisitType(visitTypes)">
                <template slot="option" slot-scope="props">
                  <b-list-group-item class="d-flex align-items-center">
                    <i :style="'color: ' + props.option.colour" class="fas fa-circle mr-2"></i><span
                      class="mr-auto title-typography-color">{{
                      props.option.text
                      }}</span>
                  </b-list-group-item>
                </template>
                <template v-if="props.option.text" slot="singleLabel" slot-scope="props"><span class="option__desc"><span
                      class="option__title"><i :style="'color: ' + props.option.colour"
                        class="fas fa-circle mr-2"></i><span class="mr-auto title-typography-color">{{
                        props.option.text
                        }}</span></span></span></template>
                <template slot="selection" slot-scope="{ values, isOpen }"><span v-if="values.length && !isOpen"
                    class="multiselect__single">{{
                    values.length
                    }}{{
                    $t(
                    "public.views.Pages.Patient.Schedule.selectedVisitType"
                    )
                    }}</span></template>
              </multiselect>
              <ul v-if="isFormVisitTypeErrors">
                <li v-for="(error, index) in validatorStep1.getErrors(
                        'visitType'
                      )" v-bind:key="index" class="form-text text-danger">
                  &nbsp;{{ error }}
                </li>
              </ul>
            </b-form-group>
          </tab-content>
          <tab-content icon="fas fa-map-marker-alt" v-bind:title="$t('public.views.Pages.Ipros.formWizard.title2')">
            <div v-if="visitType">
              <b-form-group label-for="online">
                <template slot="label">
                  {{ $t("public.views.Pages.Patient.Schedule.visitPlace") }}: *
                </template>
                <b-form-radio v-if="visitType.priceOnlineActive" v-model="online" name="online" value="true">{{
                  $t("public.views.Pages.Patient.Schedule.online")
                  }}
                </b-form-radio>
                <b-form-radio v-if="visitType.priceOfflineActive" v-model="online" name="online" value="false">{{
                  $t("public.views.Pages.Patient.Schedule.offLine")
                  }}
                </b-form-radio>
              </b-form-group>
            </div>
          </tab-content>
          <tab-content icon="fas fa-calendar-alt" v-bind:title="$t('public.views.Pages.Ipros.formWizard.title3')">
            <b-form-group label-for="dateAfter">
              <template slot="label">{{ $t("public.views.Pages.Patient.Schedule.visitDate") }}: *
              </template>
              <date-picker v-model="dateEvent" :disabled-date="disabledDate" :format="myFormat" :formatter="momentFormat"
                class="w-100" type="date" v-bind:class="{
                      'text-danger': isFormDateEventErrors,
                      'is-invalid': isFormDateEventErrors,
                    }" @change="changeDayHeadersHoursTable()"></date-picker>
              <ul v-if="isFormDateEventErrors">
                <li v-for="(error, index) in validatorStep2.getErrors(
                        'dateEvent'
                      )" v-bind:key="index" class="form-text text-danger">
                  &nbsp;{{ error }}
                </li>
              </ul>
            </b-form-group>

            <b-form-group label-for="dateAfter">
              <template slot="label">{{ $t("public.views.Pages.Patient.Schedule.hourAvaliable") }}:
                *
              </template>
              <b-table v-if="dateEvent" :fields="fields" :items="scheduleWorkschedule" hover striped>
                <template #head(monday)="data">
                  <div class="text-center">
                    <span>{{ data.label.toUpperCase() }}</span>
                    <h6>{{ data.field.date }}</h6>
                  </div>
                </template>
                <template #head(tuesday)="data">
                  <div class="text-center">
                    <span>{{ data.label.toUpperCase() }}</span>
                    <h6>{{ data.field.date }}</h6>
                  </div>
                </template>
                <template #head(wednesday)="data">
                  <div class="text-center">
                    <span>{{ data.label.toUpperCase() }}</span>
                    <h6>{{ data.field.date }}</h6>
                  </div>
                </template>
                <template #head(thursday)="data">
                  <div class="text-center">
                    <span>{{ data.label.toUpperCase() }}</span>
                    <h6>{{ data.field.date }}</h6>
                  </div>
                </template>
                <template #head(friday)="data">
                  <div class="text-center">
                    <span>{{ data.label.toUpperCase() }}</span>
                    <h6>{{ data.field.date }}</h6>
                  </div>
                </template>
                <template #head(saturday)="data">
                  <div class="text-center">
                    <span>{{ data.label.toUpperCase() }}</span>
                    <h6>{{ data.field.date }}</h6>
                  </div>
                </template>
                <template #head(sunday)="data">
                  <div class="text-center">
                    <span>{{ data.label.toUpperCase() }}</span>
                    <h6>{{ data.field.date }}</h6>
                  </div>
                </template>
                <!-- A custom formatted column -->
                <template #cell(monday)="data">
                  <div v-if="data.value.timeStart && data.value.timeEnd">
                    <b-badge :variant="
                            data.value.status === 'FREE' ? 'success' : 'danger'
                          " class="cursor-point" @click="
                            openModalInfoPay(
                              data.value.timeStart,
                              data.value.timeEnd,
                              1,
                              data.field.date,
                              data.value.status
                            )
                          ">{{ data.value.timeStart }} -
                      {{ data.value.timeEnd }}
                    </b-badge>
                  </div>
                </template>
                <template #cell(tuesday)="data">
                  <div v-if="data.value.timeStart && data.value.timeEnd" @click="
                          openModalInfoPay(
                            data.value.timeStart,
                            data.value.timeEnd,
                            2,
                            data.field.date,
                            data.value.status
                          )
                        ">
                    <b-badge :variant="
                            data.value.status === 'FREE' ? 'success' : 'danger'
                          " class="cursor-point">{{ data.value.timeStart }} -
                      {{ data.value.timeEnd }}
                    </b-badge>
                  </div>
                </template>
                <template #cell(wednesday)="data">
                  <div v-if="data.value.timeStart && data.value.timeEnd" @click="
                          openModalInfoPay(data.value.timeStart,
                            data.value.timeEnd,
                            3,
                            data.field.date,
                            data.value.status)
                        ">
                    <b-badge :variant="
                            data.value.status === 'FREE' ? 'success' : 'danger'
                          " class="cursor-point">{{ data.value.timeStart }} -
                      {{ data.value.timeEnd }}
                    </b-badge>
                  </div>
                </template>
                <template #cell(thursday)="data">
                  <div v-if="data.value.timeStart && data.value.timeEnd" @click="
                          openModalInfoPay(data.value.timeStart,
                            data.value.timeEnd,
                            4,
                            data.field.date,
                            data.value.status)
                        ">
                    <b-badge :variant="
                            data.value.status === 'FREE' ? 'success' : 'danger'
                          " class="cursor-point">{{ data.value.timeStart }} -
                      {{ data.value.timeEnd }}
                    </b-badge>
                  </div>
                </template>
                <template #cell(friday)="data">
                  <div v-if="data.value.timeStart && data.value.timeEnd" @click="
                          openModalInfoPay(
                            data.value.timeStart,
                            data.value.timeEnd,
                            5,
                            data.field.date,
                            data.value.status
                          )
                        ">
                    <b-badge :variant="
                            data.value.status === 'FREE' ? 'success' : 'danger'
                          " class="cursor-point">{{ data.value.timeStart }} -
                      {{ data.value.timeEnd }}
                    </b-badge>
                  </div>
                </template>
                <template #cell(saturday)="data">
                  <div v-if="data.value.timeStart && data.value.timeEnd" @click="
                          openModalInfoPay(
                            data.value.timeStart,
                            data.value.timeEnd,
                            6,
                            data.field.date,
                            data.value.status
                          )
                        ">
                    <b-badge :variant="
                            data.value.status === 'FREE' ? 'success' : 'danger'
                          " class="cursor-point">{{ data.value.timeStart }} -
                      {{ data.value.timeEnd }}
                    </b-badge>
                  </div>
                </template>
                <template #cell(sunday)="data">
                  <div v-if="data.value.timeStart && data.value.timeEnd" @click="
                          openModalInfoPay(
                            data.value.timeStart,
                            data.value.timeEnd,
                            0,
                            data.field.date,
                            data.value.status
                          )
                        ">
                    <b-badge :variant="
                            data.value.status === 'FREE' ? 'success' : 'danger'
                          " class="cursor-point">{{ data.value.timeStart }} -
                      {{ data.value.timeEnd }}
                    </b-badge>
                  </div>
                </template>
              </b-table>
              <b-alert v-else show variant="success">{{
                $t("public.views.Pages.Patient.Schedule.selectDate")
                }}
              </b-alert>
            </b-form-group>
            <b-row>
              <b-col cols="6">
                <b-form-group label-for="organization">
                  <template slot="label">{{
                    $t("public.views.Pages.Patient.Schedule.organization")
                    }}:
                  </template>
                  <b-avatar class="mr-3" square
                    v-bind:src="selectedOrganization.logoUrl + '/' + getAuthentication()"></b-avatar>
                  <span class="mr-auto title-typography-color">{{
                    selectedOrganization.name
                    }}</span>
                </b-form-group>
              </b-col>
              <b-col cols="6">
                <b-form-group label-for="professional">
                  <template slot="label">{{
                    $t("public.views.Pages.Patient.Schedule.professional")
                    }}:
                  </template>
                  <b-avatar class="mr-3" v-bind:src="professional.avatar"></b-avatar>
                  <span class="mr-auto title-typography-color">{{
                    professional.text
                    }}</span>
                </b-form-group>
              </b-col>
              <b-col cols="6">
                <b-form-group label-for="visitType">
                  <template slot="label">{{ $t("public.views.Pages.Patient.Schedule.visitType") }}:
                  </template>
                  <i :style="'color: ' + visitType.colour" class="fas fa-circle mr-2"></i><span
                    class="mr-auto title-typography-color">{{
                    visitType.text
                    }}</span>
                </b-form-group>
              </b-col>
              <b-col cols="6">
                <b-form-group label-for="placeVisit">
                  <template slot="label">{{ $t("public.views.Pages.Patient.Schedule.visitPlace") }}:
                  </template>
                  <b-badge v-if="online" variant="success">
                    {{ $t("public.views.Pages.Patient.Schedule.online") }}
                  </b-badge>
                  <b-badge v-else variant="danger">
                    {{ $t("public.views.Pages.Patient.Schedule.offLine") }}
                  </b-badge>
                </b-form-group>
              </b-col>
              <b-col cols="6">
                <b-form-group label-for="price">
                  <template slot="label">{{ $t("public.views.Pages.Patient.Schedule.price") }}:
                  </template>
                  <b-badge variant="success">{{ getPriceEvent() }} €</b-badge>
                </b-form-group>
              </b-col>
            </b-row>
          </tab-content>
          <template slot="footer" slot-scope="props">
            <div class="wizard-footer-left">
              <wizard-button v-if="props.activeTabIndex > 0" :style="props.fillButtonStyle"
                @click.native="clickStep1(props)">{{
                $t("public.views.Pages.Patient.Schedule.previous")
                }}
              </wizard-button>
            </div>
            <div class="wizard-footer-right">
              <wizard-button v-if="!props.isLastStep" :style="props.fillButtonStyle" class="wizard-footer-right"
                @click.native="clickStep2(props)">{{
                $t("public.views.Pages.Patient.Schedule.next")
                }}
              </wizard-button>
            </div>
          </template>
        </form-wizard>
      </template>
    </iq-card>
    <b-modal id="modal-info-pay" centered size="lg" @ok="saveFormStep1">
      <template #modal-title>{{
        $t("public.views.Pages.Patient.Schedule.modal.makeAppoiment")
      }}
      </template>
      <template #modal-ok>
        {{ $t("public.views.Pages.Patient.Schedule.modal.appoimentMake") }}
      </template>
      <template #modal-cancel>{{
        $t("public.views.Pages.Patient.Schedule.modal.cancel")
      }}
      </template>

      <b-row>
        <b-col cols="12">
          <b-form-group label-for="organizationInfo">
            <template slot="label">{{ $t("public.views.Pages.Patient.Schedule.organization") }}:
            </template>
            <ul class="list-group">
              <li class="list-group-item">
                <b-avatar class="mr-3" square
                  v-bind:src="selectedOrganization.logoUrl + '/' + getAuthentication()"></b-avatar>
                <span class="mr-auto title-typography-color">{{
                  selectedOrganization.name
                }}</span>
              </li>
            </ul>
          </b-form-group>
        </b-col>
        <b-col cols="12">
          <b-form-group label-for="professionalInfo">
            <template slot="label">{{ $t("public.views.Pages.Patient.Schedule.professional") }}:
            </template>
            <ul class="list-group">
              <li class="list-group-item">
                <b-avatar class="mr-3" square v-bind:src="professional.avatar"></b-avatar>
                <span class="mr-auto title-typography-color">{{
                  professional.text
                }}</span>
              </li>
            </ul>
          </b-form-group>
        </b-col>
        <b-col cols="6">
          <b-form-group v-if="dayInfo" label-for="dayInfo">
            <template slot="label">{{ $t("public.views.Pages.Patient.Schedule.modal.day") }}:
            </template>
            <ul class="list-group">
              <li class="list-group-item">
                {{ dayInfo }}
              </li>
            </ul>
          </b-form-group>
        </b-col>
        <b-col cols="6">
          <b-form-group v-if="dayInfo" label-for="dayInfo">
            <template slot="label">{{ $t("public.views.Pages.Patient.Schedule.modal.date") }}:
            </template>
            <ul class="list-group">
              <li class="list-group-item">
                {{ dateInfo }}
              </li>
            </ul>
          </b-form-group>
        </b-col>
        <b-col cols="6">
          <b-form-group v-if="hourStartInfo" label-for="hourStartInfo">
            <template slot="label">{{
              $t("public.views.Pages.Patient.Schedule.modal.initialHour")
            }}:
            </template>
            <ul class="list-group">
              <li class="list-group-item">
                {{ hourStartInfo }}
              </li>
            </ul>
          </b-form-group>
        </b-col>
        <b-col cols="6">
          <b-form-group v-if="hourEndInfo" label-for="hourEndInfo">
            <template slot="label">{{ $t("public.views.Pages.Patient.Schedule.modal.endHour") }}:
            </template>
            <ul class="list-group">
              <li class="list-group-item">
                {{ hourEndInfo }}
              </li>
            </ul>
          </b-form-group>
        </b-col>
        <b-col cols="6">
          <b-form-group v-if="visitType" label-for="visitType">
            <template slot="label">{{ $t("public.views.Pages.Patient.Schedule.modal.visitType") }}:
            </template>
            <ul class="list-group">
              <li class="list-group-item">
                <i :style="'color: ' + visitType.colour" class="fas fa-circle mr-2"></i>
                {{ visitType.text }}
              </li>
            </ul>
          </b-form-group>
        </b-col>
        <b-col cols="6">
          <b-form-group label-for="price">
            <template slot="label">{{ $t("public.views.Pages.Patient.Schedule.price") }}:
            </template>
            <ul class="list-group">
              <li class="list-group-item">
                <b-badge variant="success">{{ getPriceEvent() }} €</b-badge>
              </li>
            </ul>
          </b-form-group>
        </b-col>
        <b-col cols="6">
          <b-form-group label-for="placeVisit">
            <template slot="label">{{ $t("public.views.Pages.Patient.Schedule.visitPlace") }}:
            </template>
            <ul class="list-group">
              <li class="list-group-item">
                <b-badge v-if="online" variant="success">
                  {{ $t("public.views.Pages.Patient.Schedule.online") }}
                </b-badge>
                <b-badge v-else variant="danger">
                  {{ $t("public.views.Pages.Patient.Schedule.offLine") }}
                </b-badge>
              </li>
            </ul>
          </b-form-group>
        </b-col>
      </b-row>
    </b-modal>
    <b-modal id="modal-pay" centered hide-footer size="sm">
      <template #modal-title>{{
        $t("public.views.Pages.Patient.Schedule.modal.pay")
      }}
      </template>
      <template #modal-cancel>{{
        $t("public.views.Pages.Patient.Schedule.modal.cancelar")
      }}
      </template>
      <div class="payment-btn-center">
        <i v-if="user &&
            selectedOrganization &&
            selectedOrganization.paymentModePasarelaPaypal
            " id="btnPaypal" class="fab fa-paypal fa-4x fa-fw cursor-point" @click="showPaypalPayment"></i>

        <b-popover v-if="user &&
          selectedOrganization &&
          selectedOrganization.paymentModePasarelaPaypal
          " :target="'btnPaypal'" placement="botton" triggers="hover focus">
          <template #title>{{
            $t("public.views.Pages.Patient.Schedule.modal.btnPaypal")
          }}
          </template>
        </b-popover>

        <i v-if="user &&
            selectedOrganization &&
            selectedOrganization.paymentModePasarelaStripe
            " id="btnStripe" class="fab fa-stripe fa-4x fa-fw cursor-point" @click="showStripePayment"></i>

        <b-popover v-if="user &&
          selectedOrganization &&
          selectedOrganization.paymentModePasarelaStripe
          " :target="'btnStripe'" placement="botton" triggers="hover focus">
          <template #title>{{
            $t("public.views.Pages.Patient.Schedule.modal.btnStripe")
          }}
          </template>
        </b-popover>

        <i v-if="user &&
            selectedOrganization &&
            selectedOrganization.paymentModePasarelaWallet
            " id="btnWallet" class="fas fa-wallet fa-4x fa-fw cursor-point" @click="showCashPayment"></i>

        <b-popover v-if="user &&
          selectedOrganization &&
          selectedOrganization.paymentModePasarelaWallet
          " :target="'btnWallet'" placement="botton" triggers="hover focus">
          <template #title>{{
            $t("public.views.Pages.Patient.Schedule.modal.btnWallet")
          }}
          </template>
        </b-popover>
      </div>
    </b-modal>
    <notifications group="notificacions" />
  </b-container>
</template>
<script>
import { xray } from "../../../config/pluginInit";
import validator from "vue-m-validator";
import moment from "moment";

import { mapActions, mapGetters } from "vuex";
import Multiselect from "vue-multiselect";
import "vue-multiselect/dist/vue-multiselect.min.css";

import { FormWizard, TabContent, WizardButton } from "vue-form-wizard";
import "vue-form-wizard/dist/vue-form-wizard.min.css";

import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import "vue2-datepicker/locale/es";

import { loadStripe } from "@stripe/stripe-js";

import scheduleService from "../../../services/schedule";
import userService from "../../../services/user";
import organizationService from "../../../services/organization";
import iprosService from "../../../services/ipros";
import patientService from "../../../services/patient";
import utilsService from "../../../services/utils";

export default {
  name: "PatientSchedule",
  components: {
    Multiselect,
    WizardButton,
    FormWizard,
    TabContent,
    DatePicker,
  },
  data() {
    return {
      hasAnyCita: false,
      patientSchedule: [],
      scheduleWorkschedule: [],
      isFirstRun: true,
      typeSchedule: "PATIENT",
      idProfessional: null,
      validatorStep1: validator,
      validatorStep2: validator,
      visitTypeSelect: [],
      visitType: {},
      online: false,
      dateEvent: "",
      professionalSelect: [],
      professional: {},
      dateInfo: "",
      hourEndInfo: "",
      hourStartInfo: "",
      dayInfo: "",

      user: {},

      //Config date picker
      //vue2-data-picker
      myFormat: "DD/MM/YYYY",
      momentFormat: {
        //[optional] Date to String
        stringify: (date) => {
          return date ? moment(date).format("LL") : "";
        },
        //[optional]  String to Date
        parse: (value) => {
          return value ? moment(value, "LL").toDate() : null;
        },
        //[optional] getWeekNumber
        getWeek: (date) => {
          // a number
        },
      },
    };
  },
  mounted() {
    xray.index();
    //Verificacion pay
    this.verifyPay();
    this.findProfessionalsIprosOrganization();
    this.getUser();

    utilsService.auditActivity({ action: "VIEW", module: "PATIENT_SCHEDULE", info: "" });
  },
  computed: {
    isFormDateEventErrors() {
      let errors = this.validatorStep2.getErrors("dateEvent");
      return errors && errors.length > 0;
    },
    isFormVisitTypeErrors() {
      let errors = this.validatorStep1.getErrors("visitType");
      return errors && errors.length > 0;
    },
    isFormProfessionalErrors() {
      let errors = this.validatorStep1.getErrors("professional");
      return errors && errors.length > 0;
    },
    ...mapGetters({
      selectedOrganization: "Setting/organizationState",
    }),
    ...mapGetters({
      selectedUser: "Setting/userState",
    }),
  },
  methods: {
    getAuthentication() {
      return localStorage.getItem('authorization');
    },
    disabledDate(date) {
      let now = moment().subtract(1, "days").toDate();

      return now.getTime() > date.getTime();
    },
    goToDashboard() {
      if (this.user.role === "PATIENT") {
        this.$router.push({
          name: "auth.patient.dashboard",
        });
      } else {
        this.$router.push({
          name: "auth.professional.dashboard",
        });
      }
    },
    showStripePayment() {
      let self = this;

      let data = {
        organizationId: this.selectedOrganization.id,
        professionalId: this.professional.value,
        visitTypeId: this.visitType.value,
        startTime: this.hourStartInfo,
        endTime: this.hourEndInfo,
        date: moment(this.dateInfo, "DD/MM/YYYY").format(
          "YYYY-MM-DD[T]HH:mm:ss.SSS[Z]"
        ),
        online: this.online,
      };

      this.$awn.asyncBlock(
        patientService.payStripe(this.user.id, data),
        (response) => {
          if (response) {
            utilsService.auditActivity({ action: "CREATE", module: "PATIENT_PAYMENT_SUCCESS_STRIPE", info: "" });
            self.stripe = response.data;

            let stripeInit = loadStripe(self.stripe.publicKey);
            // wait for the promise to resolve first
            stripeInit.then((stripe) => {
              stripe
                .redirectToCheckout({
                  sessionId: self.stripe.idSession,
                })
                .then(function (result) {
                })
                .catch(function (error) {
                  console.error(error);
                });
            });
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "patientService.payStripe",
            module: "view-pages-patient-schedule",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              user: this.user.id, data: data
            })
          });
        },
        " "
      );
    },
    showCashPayment() {
      let self = this;
      console.log(this.dateInfo);

      let data = {
        organizationId: this.selectedOrganization.id,
        professionalId: this.professional.value,
        visitTypeId: this.visitType.value,
        startTime: this.hourStartInfo,
        endTime: this.hourEndInfo,
        date: moment(this.dateInfo, "DD/MM/YYYY").format(
          "YYYY-MM-DD[T]HH:mm:ss.SSS[Z]"
        ),
        online: this.online,
      };

      this.$awn.asyncBlock(
        patientService.payCash(this.user.id, data),
        (response) => {
          if (response) {
            utilsService.auditActivity({ action: "CREATE", module: "PATIENT_PAYMENT_SUCCESS_WALLET", info: "" });
            self.$bvModal.hide("modal-pay");
            self.$notify({
              group: "notificacions",
              title: this.$i18n.t(
                "public.views.Pages.Patient.Schedule.notification.title"
              ),
              text: this.$i18n.t(
                "public.views.Pages.Patient.Schedule.notification.descPay"
              ),
              type: "success",
            });
            self.goToDashboard();
          }
        },
        (error) => {
          if (error.response && error.response.status) {
            console.log("hola");
            console.log(error.response.status);
            if (error.response.status == 400) {
              self.$swal(
                this.$i18n.t(
                  "public.views.Pages.Patient.Schedule.errorSwal1.text"
                ),
                this.$i18n.t(
                  "public.views.Pages.Patient.Schedule.errorSwal1.text1"
                ),
                this.$i18n.t(
                  "public.views.Pages.Patient.Schedule.errorSwal1.text2"
                )
              );
            } else {
              self.$swal(
                this.$i18n.t(
                  "public.views.Pages.Patient.Schedule.errorSwal.text"
                ),
                this.$i18n.t(
                  "public.views.Pages.Patient.Schedule.errorSwal.text1"
                ),
                this.$i18n.t(
                  "public.views.Pages.Patient.Schedule.errorSwal.text2"
                )
              );
            }
          } else {
            self.$swal(
              this.$i18n.t(
                "public.views.Pages.Patient.Schedule.errorSwal.text"
              ),
              this.$i18n.t(
                "public.views.Pages.Patient.Schedule.errorSwal.text1"
              ),
              this.$i18n.t(
                "public.views.Pages.Patient.Schedule.errorSwal.text2"
              )
            );
          }
        },
        " "
      );
    },
    showPaypalPayment() {
      let self = this;

      let data = {
        organizationId: this.selectedOrganization.id,
        professionalId: this.professional.value,
        visitTypeId: this.visitType.value,
        startTime: this.hourStartInfo,
        endTime: this.hourEndInfo,
        date: moment(this.dateInfo, "DD/MM/YYYY").format(
          "YYYY-MM-DD[T]HH:mm:ss.SSS[Z]"
        ),
        online: this.online,
      };

      this.$awn.asyncBlock(
        patientService.payPaypal(this.user.id, data),
        (response) => {
          if (response) {
            utilsService.auditActivity({ action: "CREATE", module: "PATIENT_PAYMENT_SUCCESS_PAYPAL", info: "" });
            self.paypal = response.data;
            window.location.href = self.paypal.url;
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "patientService.payPaypal",
            module: "view-pages-patient-schedule",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              user: this.user.id, data: data
            })
          });
        },
        " "
      );
    },
    //Pay
    async verifyPay() {
      if (
        this.$route.query.action !== undefined &&
        this.$route.query.mode !== undefined &&
        this.$route.query.tokenback !== undefined &&
        this.$route.query.token !== undefined &&
        this.$route.query.paymentId !== undefined &&
        this.$route.query.event !== undefined &&
        this.$route.query.PayerID !== undefined
      ) {
        if (this.$route.query.action === "success") {
          let data = {
            tokenPaypal: this.$route.query.token,
            paymentIdPaypal: this.$route.query.paymentId,
            payerIDPaypal: this.$route.query.PayerID,
          };

          this.paySuccess(
            this.$route.query.patientId,
            this.$route.query.event,
            this.$route.query.mode,
            this.$route.query.tokenback,
            data
          );
        }
      }
      if (
        this.$route.query.action !== undefined &&
        this.$route.query.mode !== undefined &&
        this.$route.query.tokenback !== undefined &&
        this.$route.query.token !== undefined
      ) {
        if (this.$route.query.action === "cancel") {
          let data = {
            tokenPaypal: this.$route.query.token,
            paymentIdPaypal: this.$route.query.paymentId,
            payerIDPaypal: this.$route.query.PayerID,
          };

          this.payCancel(
            this.$route.query.patientId,
            this.$route.query.event,
            this.$route.query.mode,
            this.$route.query.tokenback,
            data
          );
        }
      }
      if (
        this.$route.query.action !== undefined &&
        this.$route.query.mode !== undefined &&
        this.$route.query.tokenback !== undefined
      ) {
        if (this.$route.query.action === "success") {
          let data = {
            tokenPaypal: "",
            paymentIdPaypal: "",
            payerIDPaypal: "",
          };

          this.paySuccess(
            this.$route.query.patientId,
            this.$route.query.event,
            this.$route.query.mode,
            this.$route.query.tokenback,
            data
          );
        }
        if (this.$route.query.action === "cancel") {
          let data = {
            tokenPaypal: "",
            paymentIdPaypal: "",
            payerIDPaypal: "",
          };

          this.payCancel(
            this.$route.query.patientId,
            this.$route.query.event,
            this.$route.query.mode,
            this.$route.query.tokenback,
            data
          );
        }
      }
    },
    paySuccess(patientId, id, mode, token, data) {
      let self = this;

      this.$awn.asyncBlock(
        scheduleService.paySuccess(patientId, id, mode, token, data),
        (response) => {
          utilsService.auditActivity({
            action: "CREATE", module: "PATIENT_PAYMENT_SUCCESS", info: ""
          });
          this.$notify({
            group: "notificacions",
            title: this.$i18n.t(
              "public.views.Pages.Patient.Schedule.notification.title"
            ),
            text: this.$i18n.t(
              "public.views.Pages.Patient.Schedule.notification.descPay"
            ),
            type: "success",
          });
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "scheduleService.paySuccess",
            module: "view-pages-patient-schedule",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              patientId: patientId, id: id, mode: mode, token: token, data: data
            })
          });
        },
        " "
      );
    },
    payCancel(patientId, id, mode, token, data) {
      let self = this;
      this.$awn.asyncBlock(
        scheduleService.payCancel(patientId, id, mode, token, data),
        (response) => {
          utilsService.auditActivity({ action: "CREATE", module: "PATIENT_PAYMENT_CANCEL", info: "" });
          this.$notify({
            group: "notificacions",
            title: this.$i18n.t(
              "public.views.Pages.Patient.Schedule.notification.error"
            ),
            text: this.$i18n.t(
              "public.views.Pages.Patient.Schedule.notification.descUnpay"
            ),
            type: "error",
          });
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "scheduleService.payCancel",
            module: "view-pages-patient-schedule",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              patientId: patientId, id: id, mode: mode, token: token, data: data
            })
          });
        },
        " "
      );
    },
    saveFormStep1() {
      this.$bvModal.show("modal-pay");
    },
    checkFormStep2() {
      this.checkDateEvent(this.dateEvent);
    },
    checkDateEvent(_date) {
      const dateEvent = _date;

      const RULE_1 = {
        expression: !dateEvent || dateEvent === "",
        name: "dateEvent",
        msg: this.$i18n.t("public.views.Pages.Patient.Schedule.errors.erDate"),
      };
      this.validatorStep2.addRule(RULE_1);
      this.notFirst();
    },
    openModalInfoPay(start, end, day, date, status) {
      if (status === "FREE") {
        this.checkFormStep2();

        if (this.user.id && this.user.role === "PATIENT") {
          if (this.validatorStep2.errors.length === 0) {
            this.hourEndInfo = end;
            this.hourStartInfo = start;
            this.dayInfo = this.myDayFormatInfo(day);
            this.dateInfo = date;
            this.$bvModal.show("modal-info-pay");
          } else {
            this.$notify({
              group: "notificacions",
              title: this.$i18n.t(
                "public.views.Pages.Patient.Schedule.notification.error"
              ),
              text: this.$i18n.t(
                "public.views.Pages.Patient.Schedule.notification.descErrorStep1"
              ),
              type: "error",
            });
          }
        }
        if (
          this.user.id &&
          (this.user.role === "PROFESSIONAL" ||
            this.user.role === "ADMIN" ||
            this.user.role === "SUPERADMIN")
        ) {
          this.$swal(
            this.$i18n.t("public.views.Pages.Patient.Schedule.errorSwal.text3"),
            this.$i18n.t("public.views.Pages.Patient.Schedule.errorSwal.text4"),
            this.$i18n.t("public.views.Pages.Patient.Schedule.errorSwal.text5")
          );
        }
        if (!this.user.id) {
          this.$refs.loginModal.openModal();
        }
      }
    },
    async getWorkscheduleByVisitType(visitType, startDate) {
      let self = this;

      let data = {
        visitType: visitType.value,
        startDate: startDate,
      };

      this.$awn.asyncBlock(
        iprosService.getPublicWorkscheduleIprosFree(
          this.professional.value,
          data
        ),
        (response) => {
          self.workscheduleIpros = response.data;
          self.generateWorkscheduleIpros();
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "iprosService.getPublicWorkscheduleIprosFree",
            module: "view-pages-patient-schedule",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              professionalId: this.professional.value, data: data
            })
          });
        }
      );
    },
    changeProfessional(professional) {
      let self = this;

      self.visitTypeMap = new Map();

      //find professional

      if (self.patientSchedule) {
        self.patientSchedule.forEach(function (item) {
          if (item.professional.id === professional.value) {
            //fill select visit type
            let combo = [];
            item.visitTypes.forEach(function (visitType) {
              self.visitTypeMap.set(visitType.id, visitType);
              combo.push({
                colour: visitType.colour,
                value: visitType.id,
                text: visitType.name,
                priceOnlineActive: visitType.priceOnlineActive,
                priceOfflineActive: visitType.priceOfflineActive,
                priceOnline: visitType.priceOnline,
                priceOffline: visitType.priceOffline,
              });
            });
            self.visitTypeSelect = combo;
          }
        });
      }
    },
    findProfessionalsIprosOrganization() {
      let self = this;

      this.$awn.asyncBlock(
        organizationService.findProfessionalsIprosOrganization(
          localStorage.getItem("organizationId")
        ),
        (response) => {
          if (response) {
            if (response.data) {
              self.patientSchedule = response.data;
              //Professional
              let combo = [];
              response.data.forEach(function (item) {
                combo.push({
                  value: item.professional.id,
                  text:
                    item.professional.name + " " + item.professional.lastname,
                  avatar: item.professional.avatarUrl
                    ? item.professional.avatarUrl +
                    "/" +
                    localStorage.getItem("authorization")
                    : "",
                });

                self.professionalSelect = combo;
              });

              self.hasAnyCita = response.data.length !== 0;
            }
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "organizationService.findProfessionalsIprosOrganization",
            module: "view-pages-patient-schedule",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              organizationId: localStorage.getItem("organizationId")
            })
          });
        },
        " "
      );
    },
    async getUser() {
      let self = this;

      this.$awn.asyncBlock(
        userService.get(localStorage.getItem("userId")),
        (response) => {
          if (response) {
            self.user = response.data;
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "userService.get",
            module: "view-pages-patient-schedule",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              userId: localStorage.getItem("userId")
            })
          });
        }
      );
    },
    changeDayHeadersHoursTable() {
      this.getWorkscheduleByVisitType(
        this.visitType,
        moment(this.dateEvent)
      );

      var dayNow = moment(new Date(this.dateEvent)).isoWeekday();

      var fildsResult = [];

      let dataMonday;

      if (dayNow !== 1) {
        dataMonday = moment(new Date(this.dateEvent));

        dataMonday = dataMonday.subtract(dayNow - 1, "days");
      } else {
        dataMonday = moment(new Date(this.dateEvent));
      }

      var j = 1;
      for (var i = 0; i <= 6; i++) {
        let dateNowTmp = moment(dataMonday);

        if (j !== 0) {
          var dateNowItem = dateNowTmp.add(j - 1, "days");
        } else {
          var dateNowItem = dateNowTmp.add(j + 6, "days");
        }
        let field = {
          key: this.getDayEnglishByInt(j),
          label: this.myDayFormatInfo(j),
          date: dateNowItem.format("DD/MM/yyyy"),
        };
        fildsResult.push(field);

        if (j === 6) {
          j = 0;
        } else {
          j++;
        }
      }

      //regenerate previous

      this.fields = fildsResult;
    },
    getPriceEvent() {
      if (this.visitType) {
        if (this.online) {
          return this.visitType.priceOnline;
        } else {
          return this.visitType.priceOffline;
        }
      }
      return "reload page";
    },
    clickStep1(props) {
      props.prevTab();
    },
    notFirst() {
      this.isFirstRun = false;
    },
    checkProfessional(_professional) {
      const professional = _professional;

      const RULE_1 = {
        expression: professional === null || !professional.value,
        name: "professional",
        msg: this.$i18n.t(
          "public.views.Pages.Patient.Schedule.errors.erProfessional"
        ),
      };
      this.validatorStep1.addRule(RULE_1);
      this.notFirst();
    },
    checkVisitType(_visitTypes) {
      const visitTypes = _visitTypes;

      const RULE_1 = {
        expression: visitTypes === null || !visitTypes.value,
        name: "visitType",
        msg: this.$i18n.t(
          "public.views.Pages.Patient.Schedule.errors.erVisitType"
        ),
      };
      this.validatorStep1.addRule(RULE_1);
      this.notFirst();
    },
    checkFormStep1() {
      this.checkProfessional(this.professional);
      this.checkVisitType(this.visitType);
    },
    //Form 1
    clickStep2(props) {
      this.checkFormStep1();
      if (this.validatorStep1.errors.length === 0) {
        this.generateWorkscheduleIpros();
        props.nextTab();
      } else {
        this.$notify({
          group: "notificacions",
          title: this.$i18n.t(
            "public.views.Pages.Patient.Schedule.notification.error"
          ),
          text: this.$i18n.t(
            "public.views.Pages.Patient.Schedule.notification.descErrorStep1"
          ),
          type: "error",
        });
      }
    },
    getDayEnglishByInt(day) {
      if (day === 1) {
        return "monday";
      }
      if (day === 2) {
        return "tuesday";
      }
      if (day === 3) {
        return "wednesday";
      }
      if (day === 4) {
        return "thursday";
      }
      if (day === 5) {
        return "friday";
      }
      if (day === 6) {
        return "saturday";
      }
      if (day === 0) {
        return "sunday";
      }
      return null;
    },
    myDayFormatInfo(day) {
      if (day === 1) {
        return this.$i18n.t("calendar.weekday.monday");
      }
      if (day === 2) {
        return this.$i18n.t("calendar.weekday.tuesday");
      }
      if (day === 3) {
        return this.$i18n.t("calendar.weekday.wednesday");
      }
      if (day === 4) {
        return this.$i18n.t("calendar.weekday.thursday");
      }
      if (day === 5) {
        return this.$i18n.t("calendar.weekday.friday");
      }
      if (day === 6) {
        return this.$i18n.t("calendar.weekday.saturday");
      }
      if (day === 0) {
        return this.$i18n.t("calendar.weekday.sunday");
      }
      return "";
    },
    myDayFormat(day) {
      if (day.weekday === 1) {
        return this.$i18n.t("calendar.weekday.monday");
      }

      if (day.weekday === 2) {
        return this.$i18n.t("calendar.weekday.tuesday");
      }

      if (day.weekday === 3) {
        return this.$i18n.t("calendar.weekday.wednesday");
      }

      if (day.weekday === 4) {
        return this.$i18n.t("calendar.weekday.thursday");
      }

      if (day.weekday === 5) {
        return this.$i18n.t("calendar.weekday.friday");
      }

      if (day.weekday === 6) {
        return this.$i18n.t("calendar.weekday.saturday");
      }

      if (day.weekday === 0) {
        return this.$i18n.t("calendar.weekday.sunday");
      }
    },
    generateWorkscheduleIpros() {
      let self = this;

      this.scheduleWorkschedule = [];

      let data = {
        monday: [],
        tuesday: [],
        wednesday: [],
        thursday: [],
        friday: [],
        saturday: [],
        sunday: [],
      };

      if (this.workscheduleIpros && this.workscheduleIpros.daySchedules) {
        this.workscheduleIpros.daySchedules.forEach(function (item) {
          if (item.day === "MONDAY") {
            let repit = new Set();

            item.hourSchedules.forEach(function (item) {
              if (!repit.has(item.timeStart)) {
                repit.add(item.timeStart);
                data.monday.push(item);
              }
            });
          }

          if (item.day === "TUESDAY") {
            let repit = new Set();

            item.hourSchedules.forEach(function (item) {
              if (!repit.has(item.timeStart)) {
                repit.add(item.timeStart);
                data.tuesday.push(item);
              }
            });
          }

          if (item.day === "WENDNESDAY") {
            let repit = new Set();

            item.hourSchedules.forEach(function (item) {
              if (!repit.has(item.timeStart)) {
                repit.add(item.timeStart);
                data.wednesday.push(item);
              }
            });
          }

          if (item.day === "THURSDAY") {
            let repit = new Set();

            item.hourSchedules.forEach(function (item) {
              if (!repit.has(item.timeStart)) {
                repit.add(item.timeStart);
                data.thursday.push(item);
              }
            });
          }

          if (item.day === "FRIDAY") {
            let repit = new Set();

            item.hourSchedules.forEach(function (item) {
              if (!repit.has(item.timeStart)) {
                repit.add(item.timeStart);
                data.friday.push(item);
              }
            });
          }

          if (item.day === "SATURDAY") {
            let repit = new Set();

            item.hourSchedules.forEach(function (item) {
              if (!repit.has(item.timeStart)) {
                repit.add(item.timeStart);
                data.saturday.push(item);
              }
            });
          }

          if (item.day === "SUNDAY") {
            let repit = new Set();

            item.hourSchedules.forEach(function (item) {
              if (!repit.has(item.timeStart)) {
                repit.add(item.timeStart);
                data.sunday.push(item);
              }
            });
          }
        });
      }

      let calculeMax = this.calculeLengthMaxDays(data);

      for (var i = 0; i < calculeMax; i++) {
        let dataFinal = {
          monday: {},
          tuesday: {},
          wednesday: {},
          thursday: {},
          friday: {},
          saturday: {},
          sunday: {},
        };
        if (i < data.monday.length) {
          if (data.monday[i].visitTypes) {
            let store = false;

            data.monday[i].visitTypes.forEach(function (visitType) {
              if (visitType.id === self.visitType.value) {
                if (!store) {
                  dataFinal.monday = data.monday[i];
                  store = true;
                }
              }
            });
          }
        }
        if (i < data.tuesday.length) {
          if (data.tuesday[i].visitTypes) {
            let store = false;

            data.tuesday[i].visitTypes.forEach(function (visitType) {
              if (visitType.id === self.visitType.value) {
                if (!store) {
                  dataFinal.tuesday = data.tuesday[i];
                }
              }
            });
          }
        }
        if (i < data.wednesday.length) {
          if (data.wednesday[i].visitTypes) {
            let store = false;

            data.wednesday[i].visitTypes.forEach(function (visitType) {
              if (visitType.id === self.visitType.value) {
                if (!store) {
                  dataFinal.wednesday = data.wednesday[i];
                  store = true;
                }
              }
            });
          }
        }
        if (i < data.thursday.length) {
          if (data.thursday[i].visitTypes) {
            let store = false;

            data.thursday[i].visitTypes.forEach(function (visitType) {
              if (visitType.id === self.visitType.value) {
                if (!store) {
                  dataFinal.thursday = data.thursday[i];
                  store = true;
                }
              }
            });
          }
        }
        if (i < data.friday.length) {
          if (data.friday[i].visitTypes) {
            let store = false;

            data.friday[i].visitTypes.forEach(function (visitType) {
              if (visitType.id === self.visitType.value) {
                if (!store) {
                  dataFinal.friday = data.friday[i];
                  store = true;
                }
              }
            });
          }
        }
        if (i < data.saturday.length) {
          if (data.saturday[i].visitTypes) {
            let store = false;

            data.saturday[i].visitTypes.forEach(function (visitType) {
              if (visitType.id === self.visitType.value) {
                if (!store) {
                  dataFinal.saturday = data.saturday[i];
                  store = true;
                }
              }
            });
          }
        }
        if (i < data.sunday.length) {
          if (data.sunday[i].visitTypes) {
            let store = false;

            data.sunday[i].visitTypes.forEach(function (visitType) {
              if (visitType.id === self.visitType.value) {
                if (!store) {
                  dataFinal.sunday = data.sunday[i];
                  store = true;
                }
              }
            });
          }
        }

        self.scheduleWorkschedule.push(dataFinal);
      }
    },
    calculeLengthMaxDays(data) {
      let max = 0;

      if (max < data.monday.length) {
        max = data.monday.length;
      }
      if (max < data.tuesday.length) {
        max = data.tuesday.length;
      }
      if (max < data.wednesday.length) {
        max = data.wednesday.length;
      }
      if (max < data.thursday.length) {
        max = data.thursday.length;
      }
      if (max < data.friday.length) {
        max = data.friday.length;
      }
      if (max < data.saturday.length) {
        max = data.saturday.length;
      }
      if (max < data.sunday.length) {
        max = data.sunday.length;
      }

      return max;
    },
  },
};
</script>
